// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions"; // ✅ Add this line

const firebaseConfig = {
  apiKey: "AIzaSyD3E7HeBLneQVlOQ476_3SR0HpAVqNWD_k",
  authDomain: "investorlanes-prod.firebaseapp.com",
  databaseURL: "https://investorlanes-prod-default-rtdb.firebaseio.com",
  projectId: "investorlanes-prod",
  storageBucket: "investorlanes-prod.firebasestorage.app",
  messagingSenderId: "456818390512",
  appId: "1:456818390512:web:e9f4ee889ff4c1be445935",
  measurementId: "G-CXWLW4D620"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app); // ✅ Export functions correctly
